module.exports = __webpack_public_path__ + "static/6-c5a9fb013cc34c24b085f003a0887b5e.png";